<template>
  <div ref="SearchModels">
    <Navbar/>

    <div id="main">
      <div class="container">
        <div class="row align-items-center text-center">
          <div class="col-md-12 px-0" v-lazy-container="{selector:'img'}">
              <img data-src="/logo/search_demo_pic002-1.png"
              data-loading="/logo/search_demo_pic002-1.png"
              style="width:100%;max-height:495px;object-fit:cover;">
              <h2 id="centered">Search Models</h2>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" class="col-12" style="background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <form class="row" @submit.prevent="submitSearch">
              <div class="col-12">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Name</label>
                    <div :class="{'control is-loading':processing}">
                      <input type="text" class="form-control" placeholder="Name" v-model="name" :disabled="processing">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Gender</label>
                    <div :class="{'control is-loading':processing}">
                      <multiselect ref="gender" v-model="gender" :options="[{id:1,name:'Male'},{id:2,name:'Female'}]" placeholder="Gender..." label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Age Range</label>
                    <div :class="{'control is-loading':processing}">
                      <multiselect ref="age_range_str" v-model="age_range_str" :options="age_range" placeholder="Age Range..." label="title" track-by="begin" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Ethnicity</label>
                    <div :class="{'control is-loading':processing}">
                      <multiselect ref="ethnicity_str" v-model="ethnicity_str" :options="countries" placeholder="Ethnicity..." label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Country</label>
                    <div :class="{'control is-loading':processing}">
                      <multiselect ref="country_id" v-model="country_id" :options="countries" placeholder="Country..." label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>City</label>
                    <div :class="{'control is-loading':processing}">
                      <multiselect ref="city_str" v-model="city_str" :options="cities" placeholder="City..." label="name" track-by="id" :multiple="true" :disabled="processing"></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center my-4">
                <button type="submit" class="btn btn-idiom btn-round mx-2 px-3"
                  :class="{'button is-loading':processing}">Search</button>
                <button type="button" class="btn btn-idiom btn-round mx-2 px-3"
                  :class="{'button is-loading':processing}" @click="clearForm">Clear</button>
              </div>
            </form>

            <div class="row" v-if="display">
              <div class="col-12 my-4">
                Search Results
              </div>
              <div class="row" v-if="display_models.length">
                <div class="col-12" v-for="(val,key) in display_models" :key="key">
                  <img class="image-fit" :src="idiom+val.primary_img" @load="onImgLoad" @click="previewModel(val)"/>
                  <div class="text-center">
                    <font color="white">{{ val.fname+" "+val.lname }}</font>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 text-center" v-if="processing && !full_search">
              <div class="spinner-border mx-2" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <Footer/>
    </div>

    <ModalModels :model="model" :show="showModal" @close="showModal=false"/>

  </div>

</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Multiselect from 'vue-multiselect'
import ModalModels from '@/components/ModalModels.vue'

export default {
  name: 'SearchModels',
  components: { Navbar, Footer, Multiselect, ModalModels },
  data(){
    return {
      processing: false,
      full_search: false,
      last_filter: null,
      this_filter: null,
      models: [],
      model: {},
      display: false,
      showModal: false,
      // .................
      display_models: [],
      // .................
      name: "",
      gender: [],
      age_range_str: [],
      ethnicity_str: [],
      country_id: [],
      city_str: [],
      // .................
      cities: [],
      countries: [],
      ethnicities: [],
      age_range: [
        {title:"0-5", begin:0, to:5},
        {title:"5-10", begin:5, to:10},
        {title:"10-15", begin:10, to:15},
        {title:"15-18", begin:15, to:18},
        {title:"18-25", begin:18, to:25},
        {title:"25-30", begin:25, to:30},
        {title:"30-35", begin:30, to:35},
        {title:"35-40", begin:35, to:40},
        {title:"40-45", begin:40, to:45},
        {title:"45-55", begin:45, to:55},
        {title:"55-65", begin:55, to:65},
        {title:"65+", begin:65, to:99},
      ]
    }
  },
  created(){
    this.models = this.LocalStorage("_IdiomtalentModels",new Array());

    this.cities = this.LocalStorage("_IdiomtalentDataCities",new Array());
    this.countries = this.LocalStorage("_IdiomtalentDataCountries",new Array());
    this.ethnicities = this.LocalStorage("_IdiomtalentDataEthnicities",new Array());

    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted(){
    if(!this.cities.length)this.get_cities();
    if(!this.countries.length)this.get_countries();
    if(!this.ethnicities.length)this.get_ethnicities();
  },
  methods:{
    async get_cities(){
      var url = this.api+'dataOption/get_cities/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          this.cities = response.data.data;
          localStorage.setItem("_IdiomtalentDataCities",JSON.stringify(response.data.data));
        }
      })
      .catch((error)=>{
        alert(error);
        console.error(error);
      })
    },
    async get_countries(){
      var url = this.api+'dataOption/get_countries/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          this.countries = response.data.data;
          localStorage.setItem("_IdiomtalentDataCountries",JSON.stringify(response.data.data));
        }
      })
      .catch((error)=>{
        alert(error);
        console.error(error);
      })
    },
    async get_ethnicities(){
      var url = this.api+'dataOption/get_ethnicities/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          this.ethnicities = response.data.data;
          localStorage.setItem("_IdiomtalentDataEthnicities",JSON.stringify(response.data.data));
        }
      })
      .catch((error)=>{
        alert(error);
        console.error(error);
      })
    },
    submitSearch(){
      this.processing = true;
      this.this_filter = JSON.stringify({
        name: this.name.trim(),
        gender: this.gender.map((e)=>e.id),
        age_range_str: this.age_range_str.map((e)=>e.name),
        country_id: this.country_id.map((e)=>e.id),
        city_str: this.city_str.map((e)=>e.name),
        ethnicity_str: this.ethnicity_str.map((e)=>e.name),
      });
      if(this.this_filter!==this.last_filter){
        this.last_filter = this.this_filter;
        this.full_search = false;
      }
      if(!this.full_search){
        this.get_models();
      }else{
        this.processing = false;
      }
      this.display_models = this.filter_models;
    },
    clearForm(){
      console.log("clearForm")
    },
    async get_models(){
      var url = this.api+'models/get_models/'+this.secret;
      var data = new FormData();
      let ignore = this.models.map(e => e.id);
      if(ignore.length){
        data.set('ignore',JSON.stringify(ignore) );
      }
      if(this.name.trim()!==""){
        data.set('name',this.name );
      }
      if(this.gender.length){
        data.set('gender',JSON.stringify(this.gender.map((e)=>e.id)) );
      }
      if(this.age_range_str.length){
        data.set('age_begin',JSON.stringify(this.age_range_str.map((e)=>e.begin)) );
      }
      if(this.country_id.length){
        data.set('country',JSON.stringify(this.country_id.map((e)=>e.name)) );
      }
      if(this.city_str.length){
        data.set('city',JSON.stringify(this.city_str.map((e)=>e.name)) );
      }
      if(this.ethnicity_str.length){
        data.set('ethnicities',JSON.stringify(this.ethnicity_str.map((e)=>e.name)) );
      }
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          this.last_filter = this.this_filter;
          this.this_filter = null;
          response.data.data.forEach((e)=>{
            let findIndex = this.models.findIndex(x => x.id == e.id);
            if(findIndex==-1)this.models.push(e);
          });
          localStorage.setItem("_IdiomtalentModels",JSON.stringify(this.models));
        }else{
          this.full_search = true;
        }
      })
      .catch((error)=>{
        console.error(error);
      })
      .then(()=>{
        this.processing = false;
        this.display = true;
      })
    },
    handleScroll() {
      let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

      if (bottomOfWindow) {
        // console.log("scrollDonwLoadMore..",e);
        if(this.display)this.submitSearch();
      }
    },
    previewModel(model){
      if(!model.primary_img){
        return false;
      }else{
        if(model.count_img>1 && !model.images){
          this.get_all_images(model);
        }else{
          this.openModal(model);
        }
      }
    },
    openModal(model){
      this.model = model;
      this.showModal = true;
    },
    async get_all_images(model){
      model.images = [];

      var url = this.api+'models/get_all_images/'+this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      data.set('models_id', model.id);
      await this.Axios.post(url, data)
      .then((response)=>{
        if(response.data.error==0){
          response.data.data.forEach((e) => {
            model.images.push(e)
          });
        }
        this.openModal(model);
      })
      .catch((error)=>{
        console.error(error);
      })
    },
  },
  computed:{
    filter_models(){
      return this.models.filter(model => {
        const fullname = model.fname+" "+model.lname;
        const searchName = fullname.toLowerCase().includes(this.name.trim()) ||
        model.fname.toLowerCase().includes(this.name.trim()) || model.lname.toLowerCase().includes(this.name.trim());
        const searchGender = (this.gender.length) ? this.gender.some(e => e.id==parseInt(model.gender)) : true;
        const searchAgeRange = (this.age_range_str.length) ? this.age_range_str.some(e => e.begin==parseInt(model.age_begin)) : true;
        const searchCountry = (this.country_id.length) ? this.country_id.some(e => model.country.toLowerCase().includes(e.name.toLowerCase())) : true;
        const searchCity = (this.city_str.length) ? this.city_str.some(e => model.city.toLowerCase().includes(e.name.toLowerCase())) : true;
        const searchEthnicity = (this.ethnicity_str.length) ? this.ethnicity_str.some(e => model.ethnicities.toLowerCase().includes(e.name.toLowerCase())) : true;
        return searchName && searchGender && searchAgeRange && searchCountry && searchCity && searchEthnicity;
      })
    }
  },
  watch:{
    showModal(val,old){
      if(old && !val)this.model = {};
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  /* #main { background-color:#aa4d8e !important; } */
  #main { background-color:#894073!important; }
  #detail{ padding: 50px; }
  #centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff !important;
  }
  .image-fit{
    height: 225px;
    width: 100%;
    object-fit: cover;
    cursor: pointer;
  }
  @media (max-width: 600px) {
    #detail{ padding: 25px; }
    #centered { font-size:18px; }
    @media (orientation: landscape) {
      .image-fit{ width: 50% !important; }
    }
  }
</style>
